<template>
	<div class="page">
		<!-- Solutions Banner -->
		<div class="solutions-banner">
			<div class="solutions-banner-img">
				<img :src="bannerList[0]?.img || require('../../assets/homeMb/swiper-mobile.png')" alt=""></img>
			</div>
			<div class="solutions-banner-text">
				<h5 class="caption-text">{{ $t('home.oneCont.title') }}</h5>
				<p class="caption-description">{{ $t('home.oneCont.cont') }}</p>
			</div>
			<div class="carousel-information" @click="openInquiryForm">
				<img src="../../assets/home/xinxi.png" alt="">
			</div>

		</div>

		<div class="solutions-swiper">
			<!-- 功能按钮 -->
			<section class="tabs">
				<button v-for="(tab, index) in swiperDataAll" :key="index" :class="['tab', { active: activeTabIndex === index }]"
					@click="tabClick(index)">
					{{ tab.title }}
				</button>
			</section>
			<div class="swiper-wrapper-box">
				<swiper ref="techSwiper" :options="customSwiperOptions" class="solutions-swiper-wrapper">
					<swiper-slide v-for="(item, index) in swiperData" :key="index" class="slide">
						<div class="service-item-img">
              <img :src="item?.subheading_img || require('../../assets/home/technology-1.png')" alt="" class="service-item-img-img"/>
            </div>
						<div :class="item.detail?'service-overlay':'service-overlay service-overlayNo'">
							<div class="service-overlay-bc"></div>
							<h3>{{ item.subheading_title }}</h3>
							<div class="service-overlay-text" v-html="item.detail"></div>
						</div>
					</swiper-slide>
					<!-- <swiper-slide class="slide">
						<img src="../../assets/home/technology-2.png" alt="" />
					</swiper-slide>
					<swiper-slide class="slide">
						<img src="../../assets/home/technology-3.png" alt="" />
					</swiper-slide>
					<swiper-slide class="slide">
						<img src="../../assets/home/technology-1.png" alt="" />
					</swiper-slide> -->
				</swiper>
			</div>
			<div class="solutions-swiper-btn-group">
				<div class="solutions-swiper-btn-group-btn">
					<img src="../../assets/homeMb/play.png" @click="start" v-if="startFlag"></img>
					<img src="../../assets/homeMb/pause.png" @click="start" v-else></img>
					<img src="../../assets/homeMb/left.png" @click="prev"></img>
					<img src="../../assets/homeMb/right.png" @click="next"></img>
				</div>
			</div>
		</div>
		<!--Solutions  Efficacy Exhibition -->
		<div class="solutions-efficacy">
			<div class="area-title-mobile">
				<p class="area-titleTop-mobile">{{ pageData[1]?.value[0]?.title }}</p>
				<p class="area-titleBottom-mobile">{{ pageData[1]?.value[0]?.subheading }}</p>
			</div>
			<div class="solutions-efficacy-content">
				<div class="solutions-efficacy-content-image">
					<img src="../../assets/solutions/content-bg.png" />
				</div>
				<div class="solutions-efficacy-content-text">
					<div class="text-2" v-html="pageData[1]?.value[0]?.content"></div>
					<!-- <div class="text-1">
						{{ pageData[1]?.value[0]?.content }}
					</div>
					<div class="text-2">
						{{ $t('solutions.efficacy.testDescription') }}
					</div>
					<div class="text-3">
						{{ $t('solutions.efficacy.usage.title1') }} | {{ $t('solutions.efficacy.usage.subtitle1') }}
					</div>
					<div class="text-3">
						{{ $t('solutions.efficacy.usage.title2') }} | {{ $t('solutions.efficacy.usage.subtitle2') }}
					</div>
					<div class="text-2">
						{{ $t('solutions.efficacy.testimonials.beforeAfter') }}
					</div>
					<div class="text-2">
						{{ $t('solutions.efficacy.testimonials.maxImprovement') }}
					</div>
					<div class="text-3">
						{{ $t('solutions.efficacy.testimonials.realExperience') }}
					</div>
					<div class="text-2">
						{{ $t('solutions.efficacy.testimonials.improvement') }}
					</div>
					<div class="text-2">
						{{ $t('solutions.efficacy.testimonials.results') }}
					</div>
					<div class="text-2">
						{{ $t('solutions.efficacy.testimonials.confidence') }}
					</div> -->
				</div>
			</div>
		</div>
		<!--Solutions Customer Reviews -->
		<div class="solutions-customer">
			<div class="area-title-mobile">
				<p class="area-titleTop-mobile">{{ $t('solutions.customerReviews.title') }}</p>
			</div>
			<rolling-barrage></rolling-barrage>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import rollingBarrage from '@/components/rollingBarrage.vue'
import { bus } from '@/utils/bus';
import { getDataList,getBannerListingMobile } from '@/api/komo.js';
import swiper from 'swiper';
export default {
	name: 'solutions',
	components: {
		Swiper,
		SwiperSlide,
		rollingBarrage
	},
	data() {
		return {
			activeTabIndex: 0,
			tabs: [this.$t('solutions.service.scalp.title'),this.$t('solutions.service.hair.title'),this.$t('solutions.service.hair.subtitle')],
			customSwiperOptions: {
				effect: 'coverflow',
				loop: true,
				loopAdditionalSlides: 1,
				// slideToClickedSlide: true,
				// coverflowEffect: {
				//     rotate: 0, // Y轴旋转角度
				//     stretch: 0, // 每个slide之间的拉伸值
				//     depth: 0, // slide的位置深度
				//     modifier: 1, // 效果倍率
				//     slideShadows: false // 禁用滑动阴影
				// },
				centeredSlides: true, // 居中显示当前slide
				slidesPerView: 1,
				// autoplay: {
				//     delay: 3000,
				//     disableOnInteraction: false
				// },
				autoplay: false,
				// 关闭默认导航按钮
				navigation: false
			},
			bannerList:[],
			pageData: [],//页面数据
			swiperDataAll: [], //所有轮播图的数据
			swiperData: [], //当前轮播图数据
			startFlag: true,
		}
	},
	computed: {
		swiper() {
			return this.$refs.techSwiper.$swiper
		},
		reviews() {
			return this.$t('solutions.customerReviews.reviews') || [];
		}
	},
	mounted() {
		
	},
	watch: {
    // 监听路由参数中的code变化
    '$route.params.code' (newCode, oldCode) {
      this.updateServiceTabFromRoute();
    }
  },
	created() {
		this.initData()
		this.updateServiceTabFromRoute();
	},
	methods: {
		updateServiceTabFromRoute () {
			console.log('this.$route.params.code',this.$route.params.code)
			if (this.$route.params.code) {
				console.log(this.swiperDataAll)
        this.swiperDataAll.forEach((item, index) => {
          if (item.code == this.$route.params.code) {
						this.activeTabIndex = index;
						this.swiperData = this.swiperDataAll[this.activeTabIndex]?.content || [];
          }
        });
      } else {
        this.activeTabIndex = 0;
      }
		},
		swiperTextClick (item, index) {
			let serviceOverlay = document.querySelectorAll('.service-overlay');
			console.log('serviceOverlay', serviceOverlay);
			// serviceOverlay[index].style.display = 'block';
		},
		handleMouseOver (event, index) {
			event.preventDefault(); // 阻止默认行为
    	event.stopPropagation(); // 阻止事件冒泡
      let imgs = document.querySelectorAll('.service-item-img-img');
			console.log('Found images:', imgs.length);
			
			if (imgs[index]) {
				imgs[index].style.filter = 'blur(5px)';
				console.log('Applied blur to image', index);
			} else {
				console.log('Image not found at index', index);
			}
    },
    handleMouseLeave(event,index) {
			event.preventDefault();
			event.stopPropagation();
			
			// 延迟清除模糊效果
			setTimeout(() => {
				let imgs = document.querySelectorAll('.service-item-img-img');
				if (imgs[index]) {
					imgs[index].style.filter = 'blur(0px)';
					console.log('Removed blur from image', index);
				}
			}, 3000);
    },
		async initData(){
			const res = await getBannerListingMobile('3')
			if (res.error == 0) {
				this.bannerList = res?.data?.list || [];
			}

			const res1 = await getDataList(localStorage?.getItem('pageId'))
			this.pageData = res1?.data?.list || [];
			this.swiperDataAll = this.pageData[0]?.value || [];
			this.swiperData = this.swiperDataAll[0]?.content || [];
		},
		// 点击tab事件
		tabClick(index) {
			this.activeTabIndex = index;
			this.swiperData = this.swiperDataAll[index]?.content || [];
			// console.log('-------------------',index,this.swiperData);
		},
		openInquiryForm(){
             bus.$emit('inquiry-form', true)
        },
		prev() {
			this.swiper.slidePrev()
		},
		next() {
			this.swiper.slideNext()
		},
		start() {
			// 如果 autoplay 被 stop 过，重新启动
			if (this.swiper.autoplay.running) {
				this.swiper.autoplay.stop();
				this.startFlag = true;
			} else {
				this.swiper.autoplay.start();
				this.startFlag = false;
			}
		},
		getRowReviews(rowIndex) {
			const totalReviews = this.reviews.length;
			const baseItemsPerRow = Math.floor(totalReviews / 4); // 基础每行数据条数
			const extraItems = totalReviews % 4; // 余数

			// 前面的行多分配一条数据，确保平均分配
			const itemsPerRow = rowIndex < extraItems ? baseItemsPerRow + 1 : baseItemsPerRow;

			// 计算当前行的起始索引
			let startIndex = 0;
			for (let i = 0; i < rowIndex; i++) {
				startIndex += i < extraItems ? baseItemsPerRow + 1 : baseItemsPerRow;
			}

			const rowReviews = this.reviews.slice(startIndex, startIndex + itemsPerRow);

			// 复制数据以实现无限滚动
			return [...rowReviews, ...rowReviews, ...rowReviews];
		},
		getAvatarImage(index) {
			const avatarIndex = (index % 3) + 1;
			return require(`@/assets/about/team-${avatarIndex}.png`);
		}
	},
}
</script>

<style scoped>
/* Solutions Banner */
.solutions-banner {
	width: 100%;
	position: relative;
}

.solutions-banner .solutions-banner-img {
	width: 100%;
}

.solutions-banner-img img {
	width: 100%;
	height: 100%;
}

.solutions-banner-text {
	position: absolute;
	left: 50%;
	top: 10%;
	transform: translateX(-50%);
	text-align: center;
	width: 100%;
}

.solutions-banner-text .caption-text {
	font-size: 6vw;
	font-weight: 800;
	color: #1e1e1e;
}

.solutions-banner-text .caption-description {
	font-weight: 100;
	font-size: 3.5vw;
	color: #1e1e1e;
}

.solutions-banner .carousel-information {
	position: fixed;
	bottom: 3%;
	right: 3%;
	width: 25vw;
	height: 25vw;
	cursor: pointer;
	z-index: 999;
}

.solutions-banner .carousel-information img {
	width: 100%;
	height: 100%;
}

/* 功能按钮 */
/* Tabs */
.tabs {
	display: flex;
	gap: 8px;
	padding: 20px 12px;
	position: sticky;
	top: 0;
	z-index: 2;
	background: linear-gradient(180deg, #ffffff 70%, transparent);
}

.tab {
	flex: 0 0 auto;
	padding: 8px 14px;
	border-radius: 999px;
	border: 1px solid #dcdcdc;
	background: #fff;
	color: #55635b;
	font-weight: 600;
}

.tab.active {
	background: #e3efe3;
	border-color: #b7d2b7;
	color: #2b3a31;
}

.solutions-swiper {
	width: 100%;
	background: #F8F9FC;
}

.solutions-swiper .swiper-wrapper-box {
	width: 100%;
}

.solutions-swiper-wrapper {
	width: 90%;
	height: 100%;
}

.solutions-swiper .swiper-wrapper-box .slide {
	width: 100%;
	overflow: hidden;
}

/* .solutions-swiper .swiper-wrapper-box .slide img {
	width: 100%;
	height: 100%;
} */
.service-item-img {
  width: 100%;
  height: 100%;
  position: relative;
}

.service-item-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: filter 0.5s ease;
}
/* 覆盖层文字 */
.service-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  padding: 3vh 4vh;
  width: 100%;
  height: 100%;
  transition: transform 0.8s ease;
  cursor: pointer;
	transform: translateY(89%);
}
.service-overlayNo{
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: white;
  padding: 3vh 4vh;
  width: 100%;
  height: 100%;
  transition: transform 0.8s ease;
  cursor: pointer;
	transform: translateY(93%);
}
.service-overlay:hover{
  transform: translateY(16%)!important;
}
.service-overlay-bc{
  background: #1E1E1E;
  box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
  border-radius: 0px 0px 30px 30px;
  opacity: 0.6;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.service-overlay h3 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  position: relative;
  z-index: 2;
  text-align: center;
  padding-bottom: 3%;
}
.service-overlay .service-overlay-text{
  font-size: 0.8rem;
  color: #FFFFFF;
  opacity: 1;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  height: 86%;
  font-weight: 100;
  position: relative;
  z-index: 2;
  overflow-y: auto;
  padding: 0 2%;
}

/* 整体滚动条容器 */
.service-overlay .service-overlay-text::-webkit-scrollbar {
  width: 8px;       /* 竖向滚动条宽度 */
  height: 10px;      /* 横向滚动条高度 */
  background: transparent; /* 轨道背景色 */
}

/* 滚动条轨道 */
.service-overlay .service-overlay-text::-webkit-scrollbar-track {
  border-radius: 5px;
  background: transparent;
  box-shadow: inset 0 0 3px rgba(0,0,0,0.1);
  border-radius: 10px;
}

/* 滚动条滑块 */
.service-overlay .service-overlay-text::-webkit-scrollbar-thumb {
  background: #a1a1a1;
  border-radius: 5px;
  border: 2px solid transparent; /* 透明边框增强视觉效果 */
  background-clip: content-box;  /* 避免背景色溢出 */
}

/* 滑块悬停状态 */
.service-overlay .service-overlay-text::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 滚动条角落 */
.service-overlay .service-overlay-text::-webkit-scrollbar-corner {
  background: transparent;
}





.solutions-swiper-btn-group {
	width: 100%;
	height: 100px;
	position: relative;
}

.solutions-swiper-btn-group-btn {
	position: absolute;
	right: 12px;
	top: 20px;
	display: flex;
	gap: 8px;
}

.solutions-swiper-btn-group-btn img {
	cursor: pointer;
	width: 8vw;
	height: 8vw;
}

/* Solutions  Efficacy Exhibition */
.solutions-efficacy {
	width: 100%;
}

.solutions-efficacy-content {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.solutions-efficacy-content .solutions-efficacy-content-image {
	width: 74%;
	height: 72vh;
	z-index: 10;
}

.solutions-efficacy-content-image img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.solutions-efficacy-content-text {
	width: 100%;
	background: #D5DCC8;
	border-radius: 20px 20px 0px 0px;
	margin-top: -20vh;
	padding: 20vh 20px 40px 20px;
	text-align: center;
}

.solutions-efficacy-content-text .text-1 {
	font-family: MicrosoftYaHei, MicrosoftYaHei;
	font-weight: bold;
	font-size: 5vw;
	color: #64715D;
	line-height: 64px;
	font-style: normal;
}
.solutions-efficacy-content-text .text-2 {
	font-size: 3vw;
	padding: 1% 0;
}
.solutions-efficacy-content-text .text-3 {
	font-size: 3vw;
	padding: 1% 0;
	font-weight: bold;
}


/* <!--Solutions Customer Reviews --> */
.solutions-customer {
	width: 100%;
	background: #F8F9FC;
}

@media (max-width: 960px)and (min-width: 781px) { 
    .service-overlay {
        transform: translateY(89%);
    }
    .service-overlayNo {
        transform: translateY(93%);
    }
		.solutions-efficacy-content .solutions-efficacy-content-image{
			height: 58vh;
		}
}
@media (max-width: 780px)and (min-width: 701px) { 
    .service-overlay {
        transform: translateY(88%);
    }
    .service-overlayNo {
        transform: translateY(91%);
    }
		.solutions-efficacy-content .solutions-efficacy-content-image{
			height: 55vh;
		}
}
@media (max-width: 700px)and (min-width: 650px) { 
    .service-overlay {
        transform: translateY(87%);
    }
    .service-overlayNo {
        transform: translateY(89%);
    }
		.solutions-efficacy-content .solutions-efficacy-content-image{
			height: 47vh;
		}
}
@media (max-width: 649px)and (min-width: 570px) { 
    .service-overlay {
        transform: translateY(86%);
    }
    .service-overlayNo {
        transform: translateY(89%);
    }
		.solutions-efficacy-content .solutions-efficacy-content-image{
			height: 45vh;
		}
}
@media (max-width: 569px)and (min-width: 490px) { 
    .service-overlay {
        transform: translateY(84%);
    }
    .service-overlayNo {
        transform: translateY(87%);
    }
		.solutions-efficacy-content .solutions-efficacy-content-image{
			height: 43vh;
		}
}
@media (max-width: 489px)and (min-width: 420px) { 
    .service-overlay {
        transform: translateY(82%);
    }
    .service-overlayNo {
        transform: translateY(85%);
    }
		.solutions-efficacy-content .solutions-efficacy-content-image{
			height: 41vh;
		}
}
@media (max-width: 419px)and (min-width: 380px) { 
    .service-overlay {
        transform: translateY(80%);
    }
    .service-overlayNo {
        transform: translateY(84%);
    }
		.solutions-efficacy-content .solutions-efficacy-content-image{
			height: 39vh;
		}
}
@media (max-width: 379px)and (min-width: 330px) { 
    .service-overlay {
        transform: translateY(78%);
    }
    .service-overlayNo {
        transform: translateY(82%);
    }
		.solutions-efficacy-content .solutions-efficacy-content-image{
			height: 37vh;
		}
}
@media (max-width: 329px) { 
    .service-overlay {
      transform: translateY(76%);
    }
    .service-overlayNo {
      transform: translateY(81%);
			padding: 2.5vh 4vh;
    }
		.solutions-efficacy-content .solutions-efficacy-content-image{
			height: 32vh;
		}
}
</style>
